import { configureStore as configureStoreReduxToolkit } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';

import { hereAutoSuggestApi } from '../../features/components/common/addressSearch/hereAutoSuggestApi';
import { rootReducer } from '../../reducers';

const rtkqMiddlewares = [hereAutoSuggestApi.middleware];

const configureStore = () =>
    configureStoreReduxToolkit({
        reducer: rootReducer(),
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(thunkMiddleware).concat(rtkqMiddlewares),
    });

const store = configureStore();
// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;

export { configureStore, store };
